<template>
  <div class="tol-list">
    <slot name="list-head"></slot>

    <ul>
      <li v-for="(item, index) in listItems" :key="index" v-on="listeners">
        <slot v-if="item.title" name="title" :value="item">{{ item.title }}</slot>
        <slot name="body" :value="item">{{ item }}</slot>
        <slot v-if="item.footnote" name="footnote" :value="item">{{ item.footnote }}</slot>
        <slot name="click-action" :value="item"></slot>
      </li>
    </ul>
    <slot name="list-foot"> </slot>
  </div>
</template>

<script>
export default {
  name: 'TolList',
  inheritedAttrs: false,
  props: {
    listItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    listeners() {
      const { ...listeners } = this.$listeners;
      return listeners;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.tol-list {
  .list-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 4px solid $row-border;
    font-weight: bold;
    span {
      display: inline-block;
      font-size: 1.2em;
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
      &.history {
        display: none;
      }
    }
  }
  &.error {
    .list-header {
      background-color: $modified-form;
      border-bottom-color: $red !important;
    }
  }

  &.rates-list {
    ul li {
      border-top: 1px solid $text-color-dark-3;
      border-bottom: 1px solid $text-color-dark-3;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 5px 0;
      &:not(:last-child) {
        border-bottom: 1px solid $row-border;
      }
      div.remove.history {
        display: none;
      }
      .list-item-label {
        flex-basis: 60%;
      }

      .tooltip {
        background-color: $black;
        z-index: 50;
        color: $white;
        font-size: 8pt;
        font-weight: bold;
        position: absolute;
        padding: 5px;
        right: 40px !important;
      }
      .remove,
      svg {
        margin-left: auto;
      }
    }
  }

  .list-footer {
    display: flex;
    padding: 30px;
  }
}
</style>
